export default __webpack_public_path__ + "atomic/_patterns/03-organisms/testimonial-carousel/_testimonial-carousel.twig";